import { createContext, useContext } from "react";
import type { DocumentFolderTemplate } from "@/hooks/use-document-folder-templates";

export interface TemplateTreeContextValue {
  // Data
  allTemplates: DocumentFolderTemplate[];

  // Pre-computed lookup map (O(1) per node instead of O(n) filter + sort)
  childTemplatesByParent: Map<number | null, DocumentFolderTemplate[]>;

  // Tree UI state
  expandedIds: Set<number>;
  toggleExpanded: (id: number) => void;

  // Rename
  renamingId: number | null;
  renameValue: string;
  setRenameValue: (v: string) => void;
  onRenameSubmit: () => void;
  onRenameCancel: () => void;
  onStartRename: (id: number, name: string) => void;

  // Create child
  creatingInParent: number | null | "root";
  newName: string;
  setNewName: (v: string) => void;
  onCreateSubmit: (parentId: number | null) => void;
  onCreateCancel: () => void;
  onStartCreate: (parentId: number) => void;

  // Template actions
  onDelete: (id: number, name: string) => void;
  isCreating: boolean;
  isAdmin: boolean;
}

export const TemplateTreeContext = createContext<TemplateTreeContextValue | null>(null);

export function useTemplateTreeContext(): TemplateTreeContextValue {
  const ctx = useContext(TemplateTreeContext);
  if (!ctx) throw new Error("useTemplateTreeContext must be used within TemplateTreeContext.Provider");
  return ctx;
}
